<template>
  <div>
    <TableVisualizationLayout :leftInfo="leftInfo" :leftAction="leftAction">
      <template slot="headerContent">
        <b-col class="pl-0 pr-0">
          <b-row class="mt-4 mb-4" align-h="between">
            <b-col class="pl-0 pr-0" sm="4">
              <b-form-input
                id="input-1"
                class="text-left"
                v-model="filterTitle"
                type="text"
                placeholder="Busque por nome ou data…"
              ></b-form-input>
            </b-col>
            <b-col class="pl-0 pr-0" sm="4"></b-col>
          </b-row>
        </b-col>
      </template>
      <template slot="table">
        <div class="scrollme">
          <b-table
            class="table-custom-assembly spaced-text"
            :fields="fields"
            :items="items"            
            v-show="mobile || !loading"
            show-empty
            empty-text="Nenhuma informação para exibir!"
          >
          
            <template #cell(isParticipant)="data">
              <div class=" d-flex justify-content-between w-100" 
                :class="getClassCustom(data.item)"></div>
            </template>
          </b-table>
          <div v-if="mobile && noMoreData && items.length > 0" class="text-center text-muted p-4">
            Não há mais registros para carregar.
          </div>
        </div>
        <div v-show="this.loading">
          <b-skeleton-table :rows="10" :columns="6"></b-skeleton-table>
        </div>
      </template>
      <template slot="footerContent">
        <div
          v-if="!mobile"
          class="d-flex bd-highlight mb-3 justify-content-between"
          :class="isMobile() ? 'flex-column-reverse' : 'flex-row'"
          style="width: 100%;"
        >
          <div
            class="mx-auto"
            :class="isMobile() ? '' : 'pagination-assembly align-self-center'"
          >
            <!-- <b-pagination
              v-model="page"
              :total-rows="totalSize"
              :per-page="perPage"
              aria-controls="my-table"
              size="lg"
            /> -->
            <Pagination 
              v-show="!this.loading"
              :current-page="page" 
              :quantity-pages="Math.ceil(totalSize / perPage)"
              @change-page="onPaginationChange"
            />
          </div>
        </div>
      </template>
    </TableVisualizationLayout>
  </div>
</template>

<script>
import TableVisualizationLayout from "../../../layouts/TableVisualizationLayout.vue";
import { resolve_path_url } from "../../../utils/image/image-utils";
import { isMobile } from "../../../utils/mobile/mobile";
import Pagination from "../../../components/base/Pagination.vue";

import { getAssemblyParticipation } from "../../../services/assembly-management/assembly-management-service";

export default {
  components: {
    TableVisualizationLayout,
    Pagination
  },
  mounted() {
    this.getAssemblys();
    
    window.addEventListener('scroll', this.handleScroll, true);
    window.addEventListener('resize', this.handleResize);
    
  },
  beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll, true);
      window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    page: {
      handler(newPage, oldPage) {
        if (!this.mobile && newPage !== oldPage) {
          this.getAssemblys();
        }
      },
    },
    filterTypeId: {
      handler() {
        this.getAssemblys();
      },
    },
    filterTitle() {
      this.resetInfiniteScroll();
    },
  },
  data() {
    return {
      mobile: window.innerWidth <= 768,
      filterTitle: "",
      page: 1,
      perPage: 10,
      totalSize: 10,
      itemToDelete: {},
      itemToUpdateStatus: {},
      statusUpdate: null,
      textModalUpdateStatus: null,
      textConfirm: null,
      msgSuccess: "",
      leftAction: {
        text: "Participação Assembleia",
        onClick: this.leftActionClickHandler,
      },
      leftInfo:
        "Acompanhe o histórico de participação nas assembleias e reuniões da UGF.",
      fields: [
        {
          key: "event",
          label: "Evento",
          thStyle: { width: "70%" },
        },
        {
          key: "eventDate",
          label: "Data",
          thStyle: { width: "20%" },
        },
        {
          key: "isParticipant",
          label: "Participação",
          thStyle: { width: "10%" },
        },
      ],
      items: [],
      loading: false,
      noMoreData: false,
      autoLoadCount: 0,
      resolve_path_url,
    };
  },
  methods: {
    isMobile: isMobile,
    handleResize() {
      const wasMobile = this.mobile;
      this.mobile = window.innerWidth <= 768;

      if (!wasMobile && this.mobile) {
        this.resetInfiniteScroll();
      }
      if (wasMobile && !this.mobile) {
        this.page = 1;
        this.getAssemblys();
      }
    },
    resetInfiniteScroll() {
      this.page = 1;
      this.items = [];
      this.noMoreData = false;
      this.autoLoadCount = 0;
      this.$nextTick(() => {
        this.getAssemblys();
      });
    },
    handleScroll(event) {
        if (!this.mobile || this.loading || this.noMoreData) return;

        // 1. Captura o alvo do evento (que provavelmente é a .app-background)
        const target = event.target;
        
        // 2. Se o evento não vier de um elemento válido (ex: disparado manualmente), 
        // tentamos buscar a div .app-background no braço
        const scrollContainer = (target && target.scrollTop !== undefined) 
            ? target 
            : document.querySelector('.app-background');

        if (!scrollContainer) return;

        const scrollTop = scrollContainer.scrollTop;
        const scrollHeight = scrollContainer.scrollHeight;
        const clientHeight = scrollContainer.clientHeight;

        // Debug para você ver no console se os valores estão mudando:
        // console.log(scrollTop, clientHeight, scrollHeight);

        if (scrollTop + clientHeight >= scrollHeight - 200) {
            this.page++;
            this.getAssemblys();
        }
    },
    async getAssemblys() {
      if (this.loading) return;

      try {
        this.loading = true;
        const response = await getAssemblyParticipation(
          this.filterTitle,
          this.page - 1,
          this.perPage
        );

        const newItems = response.items || [];
        this.totalSize = response.totalItems || 0;

        if (this.mobile) {
          // Acumula os itens
          if (newItems.length === 0) {
            this.noMoreData = true;
          } else {
            this.items = this.page === 1 ? newItems : [...this.items, ...newItems];
            
            // Se veio menos que o perPage, não tem mais dados
            if (newItems.length < this.perPage) this.noMoreData = true;

            // Lógica de preenchimento inicial (limita a 2 páginas automáticas)
            this.$nextTick(() => {
              setTimeout(() => {
                const contentHeight = document.documentElement.scrollHeight;
                const visibleHeight = window.innerHeight;
                if (contentHeight <= visibleHeight && !this.noMoreData && this.autoLoadCount < 1) {
                  this.autoLoadCount++;
                  this.page++;
                  this.getAssemblys();
                }
              }, 300);
            });
          }
        } else {
          // Desktop: Substituição simples
          this.items = newItems;
        }
      } catch (error) {
        console.error("getAssemblys", error);
      } finally {
        this.loading = false;
      }
    },
    leftActionClickHandler() {
      this.$router.go(-1);
    },
    getClassCustom(item) {
      return item?.isParticipant == true ? " custom-icon-partipation " : " custom-icon-not-partipation ";
    },
    onPaginationChange(page) {
      this.page = page;
    },
  },
};
</script>
<style lang="scss">
div.table-custom-assembly td {
  color: #7a7e83;
  padding-left: 2rem;
}
div.table-custom-assembly th {
  padding-left: 2rem;
}
</style>
<style lang="scss" scoped>
.flex-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
}
.itemleft {
  position: absolute;
  left: 0;
}
.confirm-text {
  margin: auto;
}
.custom-actions {
  width: 90%;
}
.pagination-assembly ul {
  margin-bottom: 0rem;
}
.scrollme {
  overflow-x: auto;
}
.custom-icon-partipation {
  background-image: url("../../../assets/icons/MDI-calendar-check-participation.svg");
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
  border-radius: 30px;
  background-position: center;
}

.custom-icon-not-partipation {
  background-image: url("../../../assets/icons/MDI-calendar-remove.svg");
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
  border-radius: 30px;
  background-position: center;
}
</style>
